import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import createHistory from 'history/createBrowserHistory';
import { routerReducer, routerMiddleware } from 'react-router-redux';

import reducers from './reducers';

// react-router-redux
// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-redux

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
const store = createStore(
  combineReducers({
    ...reducers,
    router: routerReducer
  }),
  // InitialState
  composeEnhancers(
    applyMiddleware(middleware),
  ),
);

export { store, history };


// WEBPACK FOOTER //
// ./src/redux/store.js